<template>
  <v-app>
    <Snackbar />
    <div class="app-wrap-content">
      <section v-if="$vuetify.breakpoint.smAndUp" class="web-view">
        <left-bar v-if="isUserLoggedIn" />
      </section>

      <section>
        <Header
          ref="header"
          v-if="
            ($route.meta.requiresAuth || $route.meta.isHeaderVisible) &&
              $vuetify.breakpoint.smAndUp
          "
        />

        <section v-if="$vuetify.breakpoint.xsOnly">
          <mobile-header
            v-if="$route.meta.requiresAuth || $route.meta.isHeaderVisible"
          />
        </section>
        <!-- class="section web-view" -->

        <v-main
          v-if="$route.meta.requiresAuth"
          :class="
            $vuetify.breakpoint.smAndUp
              ? 'section-v-main section overflow-x-hidden'
              : 'mobile-section-v-main'
          "
        >
          <div class="content-section">
            <router-view v-if="isUserLoggedIn" :key="$route.fullPath" />
            <v-main>
              <!-- <Footer
                v-if="$route.meta.requiresAuth || $route.meta.isFooterVisible"
              /> -->
            </v-main>
          </div>
        </v-main>
        <v-main v-else :class="{'section-v-main' : isUserLoggedIn}">
          <router-view  :key="$route.fullPath" />
        </v-main>
        <section v-if="$vuetify.breakpoint.xsOnly" class="mobile-view">
          <mobile-left-bar v-if="isUserLoggedIn" />
        </section>
      </section>
    </div>
    <app-version-mismatch />
  </v-app>
</template>

<script>
import { Snackbar, AppVersionMismatch } from "@/components";
import { Header, LeftBar, MobileHeader, MobileLeftBar } from "@/views/layout";
import { mapGetters } from "vuex";
export default {
  name: "App",
  components: {
    Snackbar,
    Header,
    // Footer,
    LeftBar,
    MobileHeader,
    MobileLeftBar,
    AppVersionMismatch
  },
  data: () => ({
    //
  }),
  computed: {
    ...mapGetters("user", {
      isUserLoggedIn: "isUserLoggedIn",
    }),
  },
};
</script>
<style>
.section {
  margin-left: 95px;
}
.section-v-main {
  padding: 0px;
  height: calc(100vh - 90px);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  flex: auto;
  min-height: 0;
  /* top: 105px; */
}
</style>
